import TaskButton from '@service-victoria/component-library/components/TaskButton';
import colors from '@service-victoria/component-library/utils/colors';
import styled from 'styled-components';

export const ConsentWrapper = styled.div`
  background-color: ${colors.blueGrey10};
  padding: 20px 16px 8px;
  margin-top: 10px;
`;

export const ConsentText = styled.span``;

export const EditButton = styled(TaskButton)`
  border: 1px solid ${colors.orange};
  flex-direction: row-reverse;
  justify-content: center;
  width: 150px;
  padding: 0 24px;
  margin: 36px 0 24px;
  div {
    &:nth-child(2) {
      margin-right: 10px;
    }
    color: ${colors.orange};
    .change {
      fill: ${colors.orange};
    }
  }

  &:hover {
    border: solid 1px ${colors.orange25};
    background-color: ${colors.orange25};
    div {
      color: ${colors.brown};
      .change {
        fill: ${colors.brown};
      }
    }
  }
`;

export * from '../styled';
